import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { apiCallBegan } from 'client/store/middleware/api/api';
import { IUnitTemplatesState } from 'common/interfaces/unit-templates';

const unitTemples = createSlice({
  name: 'unitTemples',
  initialState: {
    isLoading: true,
    activeTemplate: null as IUnitTemplatesState['activeTemplate'] | null,
    configuration: null as IUnitTemplatesState['configuration'] | null,
    error: null,
  },
  reducers: {
    unitTemplesRequested: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    userUnitsTemplatesDataRecieved: (state, action: PayloadAction<IUnitTemplatesState>) => {
      state.activeTemplate = action.payload.activeTemplate;
      state.configuration = action.payload.configuration;
      state.isLoading = false;
    },
    unitTemplesFailed: (state, action) => {
      state.isLoading = false;
      state.error = action.payload.message;
    },
  },
});

export const {
  unitTemplesFailed,
  unitTemplesRequested,
  userUnitsTemplatesDataRecieved,
} = unitTemples.actions;

export default unitTemples.reducer;

export const getUserUnitsTemplatesData = () => apiCallBegan({
  url: '/unit-templates/active',
  method: 'GET',
  onStart: unitTemplesRequested.type,
  onSuccess: (response: IUnitTemplatesState) => ({
    type: userUnitsTemplatesDataRecieved.type,
    payload: response,
  }),
  onError: unitTemplesFailed.type,
});